<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="合作玩法" @back="goBack" /></span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择类型">
                <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
                  <el-option
                    v-for="item in conditionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="数值">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)" @tab-remove="delCond">
            <template #label>
              <div>
                {{ getLabelName(tabItem.label) }}
                <i v-if="!checkFormData(tabItem.label)" v-permisaction="['config:rewardBuildPartnersEdit:del']" class="el-icon-circle-close" style="margin-left:5px;font-size: 14px" @click="delCond(tabItem.label)" />
              </div>
            </template>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option
                      v-for="item in conditionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-form-item label="选择分组">
                            <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 500px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                              <el-option
                                v-for="item in groups"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                          <el-form-item>
                            <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" type="danger" @click="delGroup(tabItem.label,scoreItem.group_name,scoreItem)">删除</el-button>
                          </el-form-item>
                        </el-form>
                      </div>
                      <el-form>
                        <el-form :inline="true">
                          <el-form-item label="基础倍数">
                            <el-input v-model.number="scoreItem.data[0].rewards.baseBet" placeholder="基础倍数" />
                          </el-form-item>

                          <el-form-item label="初始化给的活动道具数据">
                            <el-input v-model.number="scoreItem.data[0].rewards.initRewards" placeholder="基础倍数" />
                          </el-form-item>

                          <el-form-item label="收集物数量">
                            <el-input v-model.number="scoreItem.data[0].rewards.itemNum" placeholder="收集物数量" />
                          </el-form-item>

                          <el-form-item label="兑换比例">
                            <el-input v-model.trim="scoreItem.data[0].rewards.exchangeRate" placeholder="兑换比例" />
                          </el-form-item>
                        </el-form>
                        <el-card class="box-card">
                          <div slot="header" class="clearfix">
                            <span>建造配置</span>
                          </div>
                          <el-table :data="scoreItem.data[0].rewards.buildStageConfig" border stripe>
                            <el-table-column prop="stage" label="进度">
                              <template slot-scope="scope">
                                <el-input v-model.number="scope.row.stage" readonly placeholder="进度" />
                              </template>
                            </el-table-column>

                            <el-table-column prop="stageNum" label="进度值">
                              <template slot-scope="scope">
                                <el-input v-model.number="scope.row.stageNum" placeholder="进度值" />
                              </template>
                            </el-table-column>

                            <el-table-column prop="rewards" label="奖励配置">
                              <template slot-scope="scope">
                                <Reward :value="scope.row.rewards" />
                              </template>
                            </el-table-column>

                            <el-table-column label="操作">
                              <template slot-scope="scope">
                                <el-button v-permisaction="['config:rewardBuildPartnersEdit:del']" type="danger" @click="delBuildStage(tabItem.label,scoreItem.group_name,scope.$index)">删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <el-button class="mtop" type="primary" @click="addBuildStage(tabItem.label,scoreItem.group_name)">+</el-button>
                          <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" class="mtop" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
                        </el-card>
                        <el-card class="box-card">
                          <div slot="header" class="clearfix">
                            <span> 转盘配置 </span>
                          </div>
                          <el-table :data="scoreItem.data[0].rewards.wheelConfig" border stripe>
                            <el-table-column prop="id" label="Id">
                              <template slot-scope="scope">
                                <el-input v-model.number="scope.row.id" placeholder="Id" />
                              </template>
                            </el-table-column>
                            <el-table-column prop="v" label="权重">
                              <template slot-scope="scope">
                                <el-input v-model.number="scope.row.v" placeholder="权重" />
                              </template>
                            </el-table-column>

                            <el-table-column prop="num" label="数量">
                              <template slot-scope="scope">
                                <el-input v-model.number="scope.row.num" placeholder="数量" />
                              </template>
                            </el-table-column>

                            <el-table-column prop="stageNum" label="奖励类型">
                              <template slot-scope="scope">
                                <el-select v-model.number="scope.row.type" placeholder="请选择">
                                  <el-option
                                    v-for="item in wheelType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                  />
                                </el-select>
                              </template>
                            </el-table-column>

                            <el-table-column label="操作">
                              <template slot-scope="scope">
                                <el-button v-permisaction="['config:rewardBuildPartnersEdit:del']" type="danger" @click="delWheelConfig(tabItem.label,scoreItem.group_name,scope.$index)">删除</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <el-button v-if="scoreItem.data[0].rewards.wheelConfig.length < 11" class="mtop" type="primary" @click="addWheelConfig(tabItem.label,scoreItem.group_name)">+</el-button>
                          <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" class="mtop" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
                        </el-card>
                        <el-card class="box-card">
                          <div slot="header" class="clearfix">
                            <span>完成奖励</span>
                          </div>
                          <Reward :value="scoreItem.data[0].rewards.lastRewards" />
                          <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" class="mtop" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
                        </el-card>
                        <el-card class="box-card">
                          <div slot="header" class="clearfix">
                            <span>Bet</span>
                          </div>
                          <el-form-item>
                            <el-select v-model="scoreItem.data[0].rewards.bets" style="width: 100%;" multiple placeholder="请选择">
                              <el-option
                                v-for="item in betOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                          <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" class="mtop" :disabled="isOnline === 1" type="primary" @click="onSubmit()">保存</el-button>
                        </el-card>
                        <!--                        <el-form-item>-->
                        <!--                          <el-button v-permisaction="['config:rewardBuildPartnersEdit:add']" class="mtop" @click="onSubmit()">删除</el-button>-->
                        <!--                        </el-form-item>-->
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType } from '@/api/config/slot'
import {
  delActivtyFirstRewardCfg,
  exportActivtyRewardCfg, getActivtyRewardCfg,
  getConditionTypesList, importActivtyRewardCfg,
  updateActivtyRewardCfg
} from '@/api/config/activity-cfg'
import { getSku } from '@/api/config/shop-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import Reward from '@/components/Reward/act.vue'
export default {
  name: 'RewardBuildPartnersEdit',
  components: { Reward },
  data() {
    return {
      isOnline: 0,
      ucType: 0,
      loading: false,
      aid: 0,
      tabPane: [],
      shopSku: [],
      visibleArr: {},
      wheelType: [
        {
          'value': 1,
          'label': '正常'
        },
        {
          'value': 2,
          'label': '免费转一次'
        },
        {
          'value': 3,
          'label': '给合作伙伴发奖励'
        }
      ],
      drawer: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      conditionType: [],
      actType: '',
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level'
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: [],
      betOptions: [
        { label: '倍数1', value: 1 },
        { label: '倍数2', value: 2 },
        { label: '倍数3', value: 3 },
        { label: '倍数5', value: 5 },
        { label: '倍数10', value: 10 },
        { label: '倍数20', value: 20 },
        { label: '倍数30', value: 30 }
      ]
    }
  },
  created() {
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.getTables()
    this.getGroup()
  },
  methods: {
    bugChange(v, levelName, scoreName, index) {
      if (v === 1) {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.coinType[0].value
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      } else {
        this.formData[levelName][scoreName].data[0].rewards[index].sku = this.shopSku[0].sku
        this.formData[levelName][scoreName].data[0].rewards[index].price = this.shopSku[0].value
      }
    },
    getAvatarCfg() {
      getAvatarCfgAll().then(res => {
        const data = res.data
        for (const i in data) {
          this.avatar.push({ label: data[i].name, value: parseInt(data[i].avatar_id) })
        }
      })
    },
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, levelName, scoreName, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })

      this.formData[levelName][scoreName].data[0].rewards[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getShieldsId() {
      getShieldsAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shield.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getSieveId() {
      getSieveAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.sieve.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivtyRewardCfg({ id: this.aid, type: this.actType }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    onSubmit(noTips = false) {
      const data = JSON.stringify(this.formData)
      console.log('data', data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [type, minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const _formdata = scoreItem.data[0].rewards

          if (_formdata.baseBet <= 0) {
            this.msgError('基础倍数不能小于等于0')
            return
          }

          if (_formdata.initRewards <= 0) {
            this.msgError('初始化给的活动道具数据不能小于等于0')
            return
          }

          if (_formdata.itemNum <= 0) {
            this.msgError('收集物数量不能小于等于0')
            return
          }

          for (const k in _formdata.buildStageConfig) {
            const buildStageConfig = _formdata.buildStageConfig[k]
            if (buildStageConfig.stageNum <= 0) {
              this.msgError('建造配置-进度值不能小于等于0')
              return
            }
          }

          if (_formdata.buildStageConfig.length <= 0) {
            this.msgError('建造数据不能为空')
            return
          }

          if (_formdata.wheelConfig.length <= 0) {
            this.msgError('转盘数据不能为空')
            return
          }

          for (const k in _formdata.wheelConfig) {
            const buildStageConfig = _formdata.wheelConfig[k]
            if (buildStageConfig.v <= 0) {
              this.msgError('转盘配置-权重不能小于等于0')
              return
            }

            if (buildStageConfig.num <= 0) {
              this.msgError('转盘配置-数量不能小于等于0')
              return
            }
          }

          if (scoreItem.data[0].rewards.bets.length <= 0) {
            this.msgError('请选择bet')
            return
          }

          if (scoreItem.data[0].rewards.length <= 0) {
            this.msgError('空数据不能提交')
            return
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: scoreItem.group,
            type: 'shushu'
          }

          postFormDataCondition[key] = [condition, condition1]
          console.log('条件 ', postFormDataCondition)
          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data[0]
          }

          const _data = scoreItem.data[0]
          // _data.condition = key
          _data.aid = this.aid
          const stage = {}
          stage[key] = condition
          _data.stage = key
          _postData.push(_data)
        }
      }

      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      _postData = JSON.stringify(_postData)
      console.log('postCondition', postCondition)
      console.log('_postData', _postData)
      updateActivtyRewardCfg({ type: this.actType, name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.tabPane = []
      this.formData = []
      getActivtyRewardCfg({ id: this.aid }).then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond.condition
        for (const i in cond) {
          const val = cond[i][0]
          const val1 = cond[i][1]
          const levelName = val.type + '-' + val.start + '-' + val.end
          const scoreName = val1.shushu.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer, levelName)) {
            this.$set(this.drawer, levelName, {})
          }

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer[levelName], scoreName)) {
            this.$set(this.drawer[levelName], scoreName, [])
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          this.$set(this.formData[levelName], scoreName, {
            'group': val1.shushu,
            'group_name': scoreName,
            'group_bak': val1.shushu,
            data: [{ rewards: [] }]
          })

          for (const ii in data) {
            const _event = data[ii]
            if (_event.stage === i) {
              this.$set(this.formData[levelName][scoreName], 'data', [_event])
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              type: val.type,
              bak_type: val.type,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          this.tabPane.forEach((item, index) => {
            if (index === 0) {
              this.levelActiveName = item.label
            }
          })
        }
      })
    },
    levelChangeType(newVal, levelName) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      const oldLevelName = oldTabPane.label
      const newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === newLabelName) {
          this.msgError('当前类型配置已经存在')
          return
        }
      }
      oldTabPane.label = newLabelName
      this.tabPane[fileIndex] = oldTabPane
      this.levelActiveName = newLabelName
      if (Object.prototype.hasOwnProperty.call(this.formData, oldLevelName)) {
        const oldData = this.formData[oldLevelName]
        Vue.delete(this.formData, oldLevelName)
        this.$set(this.formData, newLabelName, oldData)
      }
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLabelName, oldVisle)
    },
    levelChange(newVal, isMin, type, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = type + '-' + bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLevelName, oldVisle)
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    delEvent(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActivtyFirstRewardCfg({ id: id }).then(res => {
            if (res.code === 200) {
              // this.formData[levelName][scoreName].data = []
              this.$delete(this.formData[levelName], scoreName)
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              // this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })
        this.$set(this.drawer[score.level_name], scoreTag, [])
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 添加第一个元素
      this.formData[score.level_name][scoreTag].data.push(
        { aid: 0, stage: [], rewards: { exchangeRate: 0, itemNum: 0, initRewards: 0, baseBet: 20, lastRewards: [], buildStageConfig: [
          {
            'stage': 1,
            'stageNum': 2500,
            'rewards': [
              {
                id: 0, type: 15, num: 1, skin: 0, rtype: 0, is_ts: 0, ts: 0
              }
            ]
          }], wheelConfig: [], bets: [] }}
      )

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      // console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        // this.msgError('等级已经存在')
        // return
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      this.tabPane.push({
        'label': levelName,
        'type': this.levelFormData.type,
        'bak_type': this.levelFormData.type,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.drawer, levelName, {})
    },
    handleClick(tab, event) {
      // console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      console.log('newGroupName', newGroupName)
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables(this.activeName)
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.drawer[levelName][oldGroupName]
      this.$delete(this.drawer[levelName], oldGroupName)
      this.$set(this.drawer[levelName], newGroupName, oldVisible)
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    removeReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[0].rewards[index].prizes = this.formData[levelName][groupName].data[0].rewards[index].prizes.filter((item, key) => {
        return i !== key
      })
    },
    getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, delCond(label) {
      this.$confirm('此操作将永久删除该条件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabPane = this.tabPane.filter(item => {
          return item.label !== label
        })
        this.$delete(this.formData, label)
        this.onSubmit(false)
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delBuildStage(levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards.buildStageConfig = this.formData[levelName][groupName].data[0].rewards.buildStageConfig.filter((item, idx) => {
        return index !== idx
      })

      this.formData[levelName][groupName].data[0].rewards.buildStageConfig.map((item, index) => {
        item.stage = index + 1
        return item
      })
    },
    delWheelConfig(levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards.wheelConfig = this.formData[levelName][groupName].data[0].rewards.wheelConfig.filter((item, idx) => {
        return index !== idx
      })

      this.formData[levelName][groupName].data[0].rewards.wheelConfig.map((item, index) => {
        item.id = index + 1
        return item
      })
    },
    addBuildStage(levelName, groupName) {
      const len = this.formData[levelName][groupName].data[0].rewards.buildStageConfig.length
      this.formData[levelName][groupName].data[0].rewards.buildStageConfig.push({
        'stage': len + 1,
        'stageNum': 0,
        'rewards': []
      })
    },
    addWheelConfig(levelName, groupName) {
      const len = this.formData[levelName][groupName].data[0].rewards.wheelConfig.length
      this.formData[levelName][groupName].data[0].rewards.wheelConfig.push({
        'id': len + 1,
        'num': 0,
        'type': 1,
        'v': 0
      })
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    },
    delGroup(levelName, scoreName, item) {
      console.log(item)
      const id = item.data[0].id
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActivtyFirstRewardCfg({ id: id }).then(res => {
            if (res.code === 200) {
              // this.formData[levelName][scoreName].data = []
              this.$delete(this.formData[levelName], scoreName)
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              // this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        })
      } else {
        this.$delete(this.formData[levelName], scoreName)
      }
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
